import { deepFreeze } from '#packages/util';

// it works partially, because we merge with repluggable store
const stateFreezer =
  (reducer: AnyFixMe) => (state: AnyFixMe, action: AnyFixMe) =>
    deepFreeze(reducer(state, action));

export default stateFreezer;
